import { Link } from 'react-router-dom';

export default function ContentSections() {
  return (
    <>
      {/* What is Kakobuy */}
      <section className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-24 bg-background-50">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div className="space-y-6">
              <span className="inline-block px-3 py-1 text-xs font-semibold tracking-wider uppercase text-secondary-700 bg-secondary-100 rounded-full">
                O platformie
              </span>
              <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950">
                Co to jest Kakobuy i dlaczego warto z niego korzystać?
              </h2>
              <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
                <p>
                  <strong className="text-foreground-900">Kakobuy</strong> to jeden z najpopularniejszych chińskich agentów zakupowych, który umożliwia kupowanie produktów z platform takich jak Taobao, Weidian i 1688. Dla polskich użytkowników stanowi bramę do świata niedrogich, wysokiej jakości replik ubrań, butów, akcesoriów i wielu innych produktów.
                </p>
                <p>
                  <strong className="text-foreground-900">Kakobuy Spreadsheet</strong> to specjalnie przygotowane arkusze z linkami do najlepszych produktów dostępnych na platformie. Dzięki nim nie musisz przeszukiwać setek stron – wszystkie sprawdzone pozycje znajdują się w jednym miejscu, posegregowane według kategorii.
                </p>
                <p>
                  Spreadsheety te są tworzone przez doświadczonych użytkowników i społeczność, którzy testują produkty, weryfikują sprzedawców i dzielą się najlepszymi znaleziskami. To narzędzie, które oszczędza czas i pieniądze każdemu, kto chce kupować z Chin.
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2">
                <div className="flex items-start gap-3 p-3 bg-background-100 rounded-lg">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 shrink-0 mt-0.5">
                    <i className="ri-search-line text-sm" />
                  </span>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900">Gotowe listy</h4>
                    <p className="text-xs text-foreground-500 mt-0.5">Produkty posegregowane tematycznie</p>
                  </div>
                </div>
                <div className="flex items-start gap-3 p-3 bg-background-100 rounded-lg">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 shrink-0 mt-0.5">
                    <i className="ri-link-m text-sm" />
                  </span>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900">Bezpośrednie linki</h4>
                    <p className="text-xs text-foreground-500 mt-0.5">Jeden klik do produktu</p>
                  </div>
                </div>
                <div className="flex items-start gap-3 p-3 bg-background-100 rounded-lg">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 shrink-0 mt-0.5">
                    <i className="ri-camera-3-line text-sm" />
                  </span>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900">QC Photos</h4>
                    <p className="text-xs text-foreground-500 mt-0.5">Zdjęcia jakości przed wysyłką</p>
                  </div>
                </div>
                <div className="flex items-start gap-3 p-3 bg-background-100 rounded-lg">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 shrink-0 mt-0.5">
                    <i className="ri-community-line text-sm" />
                  </span>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900">Społeczność</h4>
                    <p className="text-xs text-foreground-500 mt-0.5">Opinie i rekomendacje</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="aspect-[4/5] rounded-2xl overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20minimal%20product%20flat%20lay%20sneakers%20hoodie%20tshirt%20watch%20sunglasses%20tote%20bag%20arranged%20on%20warm%20cream%20marble%20surface%20soft%20diffused%20natural%20light%20editorial%20photography%20clean%20aesthetic%20high%20detail%20warm%20neutral%20tones&width=800&height=1000&seq=kakobuy-showcase-v2&orientation=portrait"
                  alt="Kakobuy Spreadsheet produkty"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-4 -left-4 md:-bottom-6 md:-left-6 bg-background-50 rounded-xl p-4 shadow-lg border border-background-200/50 max-w-[200px]">
                <div className="flex items-center gap-2 mb-2">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                    <i className="ri-star-fill text-sm" />
                  </span>
                  <span className="text-sm font-semibold text-foreground-900">5000+ produktów</span>
                </div>
                <p className="text-xs text-foreground-500">W naszej bazie znajdziesz tysiące sprawdzonych pozycji.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How to Buy */}
      <section className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-24 bg-background-100">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block px-3 py-1 text-xs font-semibold tracking-wider uppercase text-primary-700 bg-primary-100 rounded-full mb-4">
              Przewodnik
            </span>
            <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-4">
              Jak kupować z Chin przez Kakobuy?
            </h2>
            <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base">
              Proces zakupu przez Kakobuy jest prosty, gdy wiesz, co robić. Oto krok po kroku instrukcja dla początkujących.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              {
                step: '01',
                title: 'Wybierz produkt',
                desc: 'Przeglądaj nasz Kakobuy Spreadsheet lub wyszukaj produkt bezpośrednio na platformie. Skopiuj link do wybranego przedmiotu.',
              },
              {
                step: '02',
                title: 'Złóż zamówienie',
                desc: 'Wklej link do Kakobuy, wybierz rozmiar i kolor. Agent złoży zamówienie u sprzedawcy w Twoim imieniu.',
              },
              {
                step: '03',
                title: 'Sprawdź QC Photos',
                desc: 'Po dotarciu produktu do magazynu Kakobuy otrzymasz zdjęcia jakości. Dokładnie sprawdź detale przed akceptacją.',
              },
              {
                step: '04',
                title: 'Wybierz wysyłkę',
                desc: 'Po zatwierdzeniu QC wybierz metodę wysyłki do Polski. Dostępne są opcje ekonomiczne i ekspresowe.',
              },
              {
                step: '05',
                title: 'Śledź przesyłkę',
                desc: 'Otrzymasz numer trackingowy. Przesyłka do Polski zazwyczaj trwa 10-20 dni roboczych w zależności od metody.',
              },
              {
                step: '06',
                title: 'Odbierz paczkę',
                desc: 'Ciesz się swoim zakupem! Pamiętaj o cłach – w UE paczki powyżej określonej wartości mogą być opodatkowane.',
              },
            ].map((item) => (
              <div
                key={item.step}
                className="relative p-6 bg-background-50 rounded-xl border border-background-200/50 hover:border-primary-300/50 transition-colors"
              >
                <span className="absolute top-4 right-4 text-3xl font-bold font-heading text-background-200/80">
                  {item.step}
                </span>
                <h3 className="text-base font-semibold text-foreground-900 mb-2 pr-12">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Safety Section */}
      <section className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-24 bg-background-50">
        <div className="max-w-5xl mx-auto">
          <div className="bg-accent-50/50 rounded-2xl p-6 md:p-10 border border-accent-200/40">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
              <div className="space-y-5">
                <span className="inline-block px-3 py-1 text-xs font-semibold tracking-wider uppercase text-accent-700 bg-accent-100 rounded-full">
                  Bezpieczeństwo
                </span>
                <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
                  Czy Kakobuy jest bezpieczny? Oto co musisz wiedzieć
                </h2>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  Bezpieczeństwo zakupów z Chin to priorytet. Kakobuy jako agent zakupowy działa pośrednicząco – Ty płacisz Kakobuy, a oni zamawiają u sprzedawcy. Dzięki temu masz ochronę w razie problemów.
                </p>
                <ul className="space-y-3">
                  {[
                    'Weryfikacja sprzedawców przez społeczność',
                    'QC Photos – sprawdzasz produkt przed wysyłką',
                    'Możliwość zwrotu do magazynu jeśli produkt nie spełnia oczekiwań',
                    'Bezpieczne metody płatności obsługiwane przez Kakobuy',
                  ].map((item) => (
                    <li key={item} className="flex items-start gap-2.5 text-sm text-foreground-700">
                      <span className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 shrink-0 mt-0.5">
                        <i className="ri-check-line text-xs" />
                      </span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {[
                  { title: 'Sprawdź rating', desc: 'Zawsze patrz na opinie sprzedawcy przed zakupem.' },
                  { title: 'Używaj QC', desc: 'Nigdy nie akceptuj produktu bez sprawdzenia zdjęć jakości.' },
                  { title: 'Pakowanie', desc: 'Poproś o usunięcie pudełek – obniży to koszt wysyłki.' },
                  { title: 'Ubezpieczenie', desc: 'Rozważ ubezpieczenie przesyłki na wypadek zaginięcia.' },
                ].map((tip) => (
                  <div
                    key={tip.title}
                    className="p-4 bg-background-50 rounded-xl border border-background-200/50"
                  >
                    <h4 className="text-sm font-semibold text-foreground-900 mb-1">{tip.title}</h4>
                    <p className="text-xs text-foreground-500">{tip.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Article CTA */}
      <section className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-20">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-4">
            Chcesz dowiedzieć się więcej?
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto mb-8 text-sm md:text-base">
            Przygotowaliśmy szczegółowy przewodnik po Kakobuy Spreadsheet. Znajdziesz tam kompletne informacje o zakupach, bezpieczeństwie i najlepszych kategoriach produktów.
          </p>
          <Link
            to="/blog/kakobuy-spreadsheet-polska-guide-2026/"
            className="inline-flex items-center gap-2 px-8 py-4 text-base font-semibold bg-primary-500 text-background-50 rounded-xl hover:bg-primary-600 transition-colors whitespace-nowrap shadow-lg shadow-primary-500/20"
          >
            <i className="ri-book-open-line" />
            Przeczytaj kompletny przewodnik Kakobuy
          </Link>
        </div>
      </section>
    </>
  );
}